var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReactionWow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "current",
    fillRule: "evenodd",
    d: "M15.897 31.794C7.117 31.794 0 24.677 0 15.897 0 7.117 7.117 0 15.897 0c8.78 0 15.897 7.117 15.897 15.897 0 8.78-7.118 15.897-15.897 15.897z",
    transform: "translate(-259 -1271) translate(39 1271) translate(220)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2E3742",
    d: "M22.393 20.196c-.259 4.005-2.69 7.108-5.43 6.932-2.74-.177-4.752-3.566-4.494-7.57.258-4.005 2.689-7.109 5.429-6.932 2.74.176 4.752 3.565 4.495 7.57M26.724 10.694c0 1.845-1.242 3.34-2.773 3.34-1.532 0-2.773-1.495-2.773-3.34 0-1.845 1.241-3.34 2.773-3.34 1.531 0 2.773 1.495 2.773 3.34M14.39 10.02c0 1.846-1.242 3.342-2.774 3.342s-2.773-1.496-2.773-3.342c0-1.844 1.241-3.34 2.773-3.34s2.774 1.496 2.774 3.34",
    transform: "translate(-259 -1271) translate(39 1271) translate(220)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FA5F5F",
    d: "M19.999 23.837c0 1.3-1.306 2.355-2.916 2.355-1.61 0-2.916-1.054-2.916-2.355 0-1.3 1.305-2.355 2.916-2.355 1.61 0 2.916 1.054 2.916 2.355",
    transform: "translate(-259 -1271) translate(39 1271) translate(220)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReactionWow);
export default __webpack_public_path__ + "static/media/reactionWow.efe33222.svg";
export { ForwardRef as ReactComponent };